<template>
    <h2 class="heading">Payment Form</h2>
    <div class="form">
        <el-form :model="payment" label-width="250px" style="width:1100px" >
            <el-form-item label="Payment Category" required>
                <el-select v-model="payment.category" placeholder="Payment category" style="width:220px" >
                    <el-option v-for="cat in categories" :key="cat" :label="cat" :value="cat">
                    </el-option>
                </el-select>
                <el-input v-model="payment.category2" v-if="payment.category=='Others'" placeholder="Others please specify"
                    style="width:250px; margin-left:10px;" maxlength="50" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Purpose of payment" required>
                <el-input v-model="payment.purpose" minlength="2" maxlength="100" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Description" v-if="payment.status != 'rejected'">
                <el-input v-model="payment.description" type="textarea" maxlength="500" show-word-limit="true"></el-input>
            </el-form-item>
            <el-form-item label="Request date" required>
                <el-date-picker v-model="payment.requestDate" type="date" placeholder="Request Date" value-format="YYYY-MM-DD"></el-date-picker>
            </el-form-item>
            <el-form-item label="Requester" required>
                <el-select v-if="global.hasRight('payments', 'statistician')" v-model="payment.requester" placeholder="Select User">
                    <el-option v-for="user in allUsers" :key="user.id" :label="user.fullname" :value="user.loginname"/>
                </el-select>
                <el-input v-else v-model="currentUser.fullname" readonly="true" style="background:#ffe !important;"/>
            </el-form-item>

            <el-form-item label="Contract">
                <el-autocomplete v-model="contractId"
                    :fetch-suggestions="queryContract"
                    :trigger-on-focus="false" clearable class="inline-input"
                    placeholder="Ticker, vendor, service or contract ID"
                    @select="selectItem"/>
            </el-form-item>
            <el-form-item label="Contract Info">
                <template v-if="contract"><span class="contractDetails">
                    ID: <span> #{{contract.id}} </span>, 
                    Nature: <span> {{ contract.nature }} </span>, 
                    Vendor: <span>{{ contract.vendorName }}</span>, 
                    Service: <span>{{ contract.service }}</span>, 
                    Related ETFs: <span>{{ contract.relatedETFs }}</span>, <br/>
                    Contract Amount: <span>{{ contract.currency }} <b style="color:#369; font-size:1.0em;">{{ contract.contractAmount }}</b></span>,  
                    Billding Frequency: <span>{{ contract.billingFrequency }}</span>, 
                    Billding Period: <span>{{ contract.billingPeriod }}</span>, 
                    <template v-if="/[0-9,]+/.test(contract.relatedETFs)">
                        AUM Details: click <a class="link" href="" @click.prevent="exportAUM">here</a>
                    </template><br/> 
                    Fee Calculation: <span>{{ contract.feeCalculation }}</span>
                </span></template>
                <template v-else-if="contractMsg"><span class="errMsg" style="margin-left:0px;padding-left:8px;">{{ contractMsg }}</span></template>
            </el-form-item>

            <el-form-item label="Payment related to">
                <el-input v-model="payment.relatedTo" maxlength="50" show-word-limit="true"/>
            </el-form-item>
            <el-form-item label="Related ETFs">
                <el-select v-model="payment.etf" placeholder="Related ETFs" @change="selectETF" style="width:220px">
                    <el-option v-for="etf in ETFs" :key="etf" :label="etf" :value="etf" />
                </el-select>
                <el-tag v-for="etf in selectedETFs" :key="etf" closable="true" 
                    style="margin-left:10px;" size="large" @close="removeEtfTag(etf)" >{{ etf }}</el-tag>
            </el-form-item>
            
            <el-form-item label="Pay from" required>
                <el-select v-model="payment.payFrom" placeholder="Pay from" style="width:220px">
                    <el-option v-for="payFrom in payFroms" :key="payFrom" :label="payFrom" :value="payFrom"/>
                </el-select>
            </el-form-item>
            <el-form-item label="Pay to" required>
                <el-input v-model="payment.payTo" maxlength="60" show-word-limit="true" />
            </el-form-item>
            <el-form-item label="Invoice number">
                <el-input v-model="payment.invoiceNumber" maxlength="50" show-word-limit="true" />
            </el-form-item>
            <el-form-item label="Invoice date">
                <el-date-picker v-model="payment.invoiceDate" type="date" placeholder="Invoice date" value-format="YYYY-MM-DD"></el-date-picker>
            </el-form-item>
            
            <el-form-item label="Invoice files">
                <el-tag v-for="(item, index) in invoiceFiles" :key="index" size="large" closable @close="removeFile(item)">
                    <a href="" @click.prevent="global.down(item.link, item.name)">{{item.name}}</a></el-tag>
                <el-upload multiple :action="global.upload_path"
                    :on-success="uploaded"
                    :data="{'type':'payments'}"
                    :show-file-list="false">
                    <el-button type="primary">Click to upload</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label="Payment date">
                <el-date-picker v-model="payment.paymentDate" type="date" placeholder="Payment date" value-format="YYYY-MM-DD"></el-date-picker>
            </el-form-item>
            <el-form-item label="Payment method" required>
                <el-select v-model="payment.paymentMethod" placeholder="Payment method" style="width:220px">
                    <el-option v-for="method in paymentMethods" :key="method" :label="method" :value="method"/>
                </el-select>
            </el-form-item>

            <el-form-item label="Amount" required>
                <el-input-number v-model="payment.amount" :min="0" :max="1000000" precision="2" controls-position="right"  @change="calcAmount" />
                <el-select v-model="payment.currency" placeholder="Currency" style="margin-left:10px; width:180px;" >
                    <el-option v-for="ccy in currencys" :key="ccy" :label="ccy" :value="ccy" />
                </el-select>
            </el-form-item>
            <el-form-item label="FX rate">
                <el-input-number v-model="payment.fxRate" :min="0" :max="1000000" precision="6" controls-position="right" @change="calcAmount" />
            </el-form-item>

            <el-form-item label="Amount">
                <el-input-number v-model="payment.amountHKD" :min="0" :max="1000000" precision="2" controls-position="right" />
                <span class="unit">HKD</span>
            </el-form-item>
            <el-form-item label="Service Charge">
                <el-input-number v-model="payment.serviceChargeHKD" :min="0" :max="1000000" precision="2" controls-position="right" />
                <span class="unit">HKD</span>
            </el-form-item>
            <el-form-item label="Commission or other changes">
                <el-input-number v-model="payment.commissionChargeHKD" :min="0" :max="1000000" precision="2" controls-position="right" />
                <span class="unit">HKD</span>
            </el-form-item>
            <el-form-item label="Postage / cable fees">
                <el-input-number v-model="payment.postageHKD" :min="0" :max="1000000" precision="2" controls-position="right" />
                <span class="unit">HKD</span>
            </el-form-item>
            <el-form-item label="Additional handling charges">
                <el-input-number v-model="payment.additionalChargesHKD" :min="0" :max="1000000" precision="2" controls-position="right" />
                <span class="unit">HKD</span>
            </el-form-item>
            <el-form-item label="Total amount">
                <el-input-number v-model="totalAmountHKD" :min="0" :max="1000000" precision="2" controls-position="right" readonly="true"/>
                <span class="unit">HKD</span>
            </el-form-item>
            <el-form-item label="Reference number">
                <el-input v-model="payment.referenceNumber" maxlength="60" show-word-limit="true" />
            </el-form-item>
            <el-form-item label="Reimbursement from">
                <el-select v-model="payment.reimbursementFrom" placeholder="Reimbursement from" style="width:220px">
                    <el-option v-for="payFrom in payFroms" :key="payFrom" :label="payFrom" :value="payFrom" />
                </el-select>
            </el-form-item>
            <el-form-item label="Reimbursement date">
                <el-date-picker v-model="payment.reimbursementDate" type="date" placeholder="Reimbursement date" 
                    value-format="YYYY-MM-DD" style="width:220px"></el-date-picker>
            </el-form-item>
            <el-form-item label="Sign-off by" required>
                <el-select v-model="payment.dept" placeholder="Department" @change="selectDept" style="width:220px">
                    <el-option v-for="dept in DEPARTMENTS" :key="dept" :label="dept" :value="dept" />
                </el-select>
                <el-tag v-for="dept in signoffDepts" :key="dept" closable="true" 
                    style="margin-left:15px;" size="large" @close="removeTag(dept)" >{{ dept }}</el-tag>
            </el-form-item>
            <el-form-item label="Approver" required>
                <el-select v-model="payment.approver" placeholder="Approver" style="width:220px">
                    <el-option v-for="approver in approvers" :key="approver" :label="approver" :value="approver" />
                </el-select>
            </el-form-item>
            <el-form-item v-if="payment.approverComments && payment.approverComments != '' && payment.status == 'rejected'" label="Approver's comments">
                <span style="color:#e33;font-weight:bold;">{{payment.approverComments}}</span>
            </el-form-item>
            <el-form-item label="Requester's remarks" v-else>
                <el-input v-model="payment.requesterRemarks" type="textarea" maxlength="500" show-word-limit="true"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="submitPayment">Submit</el-button> 
                <el-button type="default" onclick="history.back()" >Cancel</el-button>
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
                <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                    <img src="@/assets/loading.gif" style="height:24px;"/>
                </span>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

const categories = ['System and Market Data', 'Index Fees', 'Market Data', 'Front-to-Back Office System', 'Legal Fees', 
                    'Project Consulting',  'Professional Services', 'Marketing Communication', 'IT Services', 
                    'IT Equipment (Hardware)', 'IT Software Licenses', 'Other Fixed Assets', 'Others'];
const payFroms = ['N/A', 'company account', 'portfolio account'];
const paymentMethods = ['Cheque', 'Telegraphic Transfer', 'Chats', 'Petty Cash'];
const currencys = ['USD', 'HKD', 'RMB', 'EUR', 'GBP', 'SGP', 'NZD', 'CHF'];
const DEPARTMENTS =['Compliance','Admin','Finance and Admin','Investment','Trading',
                    'Operations','IT','Product','Clients','Research','Partners', 'Confirm1', 'Confirm2'];
const ETFs = ['All', '2803', '3173', '2810', '3181', '2804', '3077', '9078', '2817', '9177', '3001', '3151', '3411', '3453', '9159', '3478'];
const approvers =['Rebecca Chua']
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            categories, payFroms, currencys, paymentMethods, DEPARTMENTS, approvers, ETFs,
            payment: {
                id: null, 
                purpose: '',
                requestDate: '',
                requester: '',
                creator: '',
                relatedTo: '',
                etf: null,
                relatedETFs: '',
                category: '',
                category2: '',
                payFrom: '',
                payTo: '',
                invoiceNumber: '',
                invoiceDate: '',
                invoiceFiles: '',
                paymentDate: '',
                paymentMethod: '',
                amount: 0.0,
                currency: '',
                fxRate: 1.0,
                amountHKD: 0,
                serviceChargeHKD: 0,
                commissionChargeHKD: 0,
                postageHKD: 0,
                additionalChargesHKD: 0,
                totalAmountHKD: 0,
                referenceNumber: '',
                reimbursementFrom: null,
                reimbursementDate: '',
                dept: '',
                departments: '',
                approver: '',
                approverComments: '',
                requesterRemarks: '',
                signOff: '',
                description: '',
                allContracts: [],
            },
            contractId: null,
            contract: null,
            contractMsg : null,
            allUsers: null,
            currentUser: null,
            errMsg: '',
            global,
            loading: false,
        }
    },
    watch: {
         contractId: async function(newVal, oldVal) {
             this.contractMsg = null;
             this.contract = null;
             if (newVal && /[0-9]+/.test(newVal)) {
                 let result = await AXIOS("/contract/getContract", {contractId: newVal});
                 if (result.success) {
                     this.contract = result.data;
                 }
             }
         }
    },
    computed: {
        totalAmountHKD() {
            return this.payment.amountHKD  + this.payment.serviceChargeHKD + this.payment.commissionChargeHKD
                 + this.payment.postageHKD + this.payment.additionalChargesHKD;
        },
        invoiceFiles() {
            let files = new Array();
            if (this.payment.invoiceFiles && this.payment.invoiceFiles.length) {
                let filesArr = this.payment.invoiceFiles.split(";")
                for (var i = 0; i < filesArr.length; i++) {
                    files.push({
                        name: filesArr[i].split(":")[0], 
                        link: filesArr[i].split(":")[1]
                    });
                }
            }
            return files;
        },
        signoffDepts() {
            if (this.payment.departments && this.payment.departments.length) 
                return this.payment.departments.split(",");
            return new Array();
        },
        selectedETFs() {
            if (this.payment.relatedETFs && this.payment.relatedETFs.length) 
                return this.payment.relatedETFs.split(",");
            return new Array();
        }
    },
    async created() {
        this.global.index = "payment";
        this.currentUser = this.global.currentUser;
        this.payment.requester = this.currentUser.loginname;
        if (this.global.hasRight('payments', 'statistician')) {
            this.allUsers = await this.global.getAllUsers();
        }
    },
    async mounted() {
        let code = this.$route.query ? this.$route.query.code : null;
        let action = this.$route.query && this.$route.query.action ?  this.$route.query.action : null;
        let result = await AXIOS("/payment/getAllContracts");
        if (result.success) {
            this.allContracts = result.data;
        }

        if (code) {
            let result = await AXIOS("/payment/getPaymentByCode", {code: code});
            if (result.success) {
                this.payment = result.data.payment;
                if (this.payment && this.payment.contractId)
                    this.contractId = this.payment.contractId;
                if (action == 'copy') {
                    this.payment.purpose = "Copy of " + this.payment.purpose;
                    this.payment.requester = this.currentUser.loginname;
                    this.payment.id = null;
                    this.payment.invoiceNumber = '';
                    this.payment.invoiceFiles = '';
                    this.payment.invoiceDate = '';
                    this.payment.paymentDate = '';
                    this.payment.requestDate = '';
                    this.payment.lastupdate = '';
                    this.payment.createTime = '';
                    this.payment.signOff = '';
                    this.payment.approverComments = '';
                }
            } else {
                this.errMsg = result.errMsg;
            }
        }
    },
    methods: {
        selectDept() {
            if (this.payment.departments.indexOf(this.payment.dept) == -1) { //未选过的部门添加到已选部门后面
                if (this.payment.departments.length > 0)
                    this.payment.departments += "," +  this.payment.dept;
                else this.payment.departments = this.payment.dept;
            }
        },
        selectETF() {
            if (this.payment.relatedETFs.indexOf(this.payment.etf) == -1) { //未选过的ETF添加到已选ETF后面
                if (this.payment.relatedETFs.length > 0)
                    this.payment.relatedETFs += "," +  this.payment.etf;
                else this.payment.relatedETFs = this.payment.etf;
            }
        },
        removeTag(dept) {
            let depts = (this.payment.departments + ",").replace(dept+",", "")
            this.payment.departments = (depts.length > 0) ? depts.substring(0, depts.length-1) : "";
        },
        removeEtfTag(etf) {
            let etfs = (this.payment.relatedETFs + ",").replace(etf+",", "")
            this.payment.relatedETFs = (etfs.length > 0) ? etfs.substring(0, etfs.length-1) : "";
        },
        removeFile(item) {
            let invoiceFiles = (this.payment.invoiceFiles + ";").replace(item.name+":"+item.link+";", "")
            this.payment.invoiceFiles = (invoiceFiles.length == 0) ? "" : invoiceFiles.substring(0, invoiceFiles.length-1);
        },
        uploaded(response) {
            let files = response.length ? response[0].name + ":" + response[0].url : '';
            if (files != '' && this.payment.invoiceFiles.indexOf(files) == -1) {
                this.payment.invoiceFiles = (this.payment.invoiceFiles == '') ? 
                    files : this.payment.invoiceFiles + ";" + files;
            }
        },
        selectItem(item) {
            this.contractId = item.name;
        },
        queryContract(keywords, callback) {
            keywords = keywords.toLowerCase();
            let result1 = [];
            let result2 = [];
            let result3 = [];
            let result4 = [];
            let result5 = [];
            for (let i = 0; i < this.allContracts.length; i++) {
                let item = this.allContracts[i];
                let contractId = item.name;
                let vendorName = item.value.split(" - ")[2];
                let service = item.value.split(" - ")[3];
                let relatedETFs = item.value.split(" - ")[4];

                if (contractId == keywords) {
                    result1.push(item);
                    break;
                }
                else if (vendorName.toLowerCase().indexOf(keywords) > -1)
                    result2.push(item);
                else if (service.toLowerCase().indexOf(keywords) > -1)
                    result3.push(item);
                else if (relatedETFs.toLowerCase().indexOf(keywords) > -1)
                    result4.push(item);
                else if (relatedETFs.toLowerCase() == 'all' && /[0-9]{4,5}/.test(keywords))
                    result5.push(item);
            }
            return callback(result1.concat(result2).concat(result3).concat(result4).concat(result5));
        },

        calcAmount() {
            if (this.payment.fxRate && this.payment.amount) {
                this.payment.amountHKD = Math.round(this.payment.fxRate * this.payment.amount * 100) / 100.0;
            }
        },

        exportAUM() {
            let token = encodeURIComponent(this.global.token);
            window.location.href = this.global.api_domain+"/payment/exportAUM?code=" + this.contract.idMD5 + "&x-token=" + token;
        },

        async submitPayment() {
            this.errMsg = "";
            if (this.payment.purpose == "") {
                this.errMsg = "[Purpose of payment] is required";
                return;
            }
            if (this.payment.requestDate == "") {
                this.errMsg = "[Request date] is required";
                return;
            }
            if (this.payment.requester == "") {
                this.errMsg = "[Requester] is required";
                return;
            }
            if (this.payment.category == "") {
                this.errMsg = "[Payment Category] is required";
                return;
            }
            if (this.payment.category == "Others" && this.payment.category2 == "") {
                this.errMsg = "Please specify other category";
                return;
            }
            if (this.payment.payFrom == "") {
                this.errMsg = "[Pay from] is required";
                return;
            }
            if (this.payment.payTo == "") {
                this.errMsg = "[Pay to] is required";
                return;
            }
            if (this.payment.paymentMethod == "") {
                this.errMsg = "[Payment method] is required";
                return;
            }
            if (this.payment.amount == 0.0) {
                this.errMsg = "[Amount] is required";
                return;
            }
            if (this.payment.currency == "") {
                this.errMsg = "[Currency] is required";
                return;
            }
            if (this.payment.departments.length == 0) {
                this.errMsg = "[Review by] is required";
                return;
            }
            if (this.payment.approver == '') {
                this.errMsg = "[Approver] is required";
                return;
            }
            
            if (this.loading) return;
            this.loading = true;
            this.payment.signOffList = null;
            this.payment.lastupdate = null;
            this.payment.createTime = null;
            this.payment.totalAmountHKD = this.totalAmountHKD;
            if (this.contract) this.payment.contractId = this.contractId;
            else this.payment.contractId = null;
            
            let result = await AXIOS("/payment/savePayment", this.payment);
            if (result.success) {
                this.$router.push("/payment/myPaymentList");
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .heading { width:900px; }
    .unit {margin-left:5px;}
    .el-select {max-length:300px;}
    .link {color: #369;}
    .contractDetails { color:#999; font-size:13px; }
    .contractDetails span {color:#333; text-decoration: underline;}
</style>